export default {
	EM_PROCESSAMENTO: { value: 'EM_PROCESSAMENTO', text: 'Em Processamento' },
	ERRO: { value: 'ERRO', text: 'Erro' },
	CONCLUIDO: { value: 'CONCLUIDO', text: 'Concluido' },
}
